import Vue from 'vue'
// Use it to import all Vue file containing this folder as Components
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('home', require('./home').default);
Vue.component('pages-404', require('./utility/404').default);

Vue.component("login", require("./account/login").default);
Vue.component("register", require("./account/register").default);
Vue.component("forgot-password", require("./account/forgot-password").default);
Vue.component("reset-password", require("./account/reset-password").default);

Vue.component("crear-procesos", require("./procesos/crear-procesos").default);
Vue.component("crear-colegios", require("./colegios/crear-colegios").default);
Vue.component("agregar-usuarios", require("./usuarios/agregar-usuarios").default);
Vue.component("asignar-director", require("./usuarios/asignar-director").default);
Vue.component("asignar-usuarios", require("./usuarios/asignar-usuarios").default);
Vue.component("asignar-supervision", require("./usuarios/asignar-supervision").default);
Vue.component("asignar-coevaluacion", require("./usuarios/asignar-coevaluacion").default);

Vue.component("evaluaciones-todas", require("./evaluaciones/evaluaciones-todas").default);
Vue.component("evaluaciones-coevaluacion", require("./evaluaciones/evaluaciones-coevaluacion").default);
Vue.component("evaluaciones-deljefe", require("./evaluaciones/evaluaciones-deljefe").default);
Vue.component("evaluaciones-retroalimentacion", require("./evaluaciones/evaluaciones-retroalimentacion").default);

Vue.component("jefedepartamento", require("./evaluaciones/evaluacion-jefedepartamento").default);
Vue.component("profesorjefe", require("./evaluaciones/evaluacion-profesorjefe").default);
Vue.component("encargadoconvivencia", require("./evaluaciones/evaluacion-encargadoconvivencia").default);
Vue.component("docente", require("./evaluaciones/evaluacion-docente").default);
Vue.component("coordinadoracademico", require("./evaluaciones/evaluacion-coordinadoracademico").default);
Vue.component("auxiliar", require("./evaluaciones/evaluacion-auxiliar").default);
Vue.component("asistenteeducacion", require("./evaluaciones/evaluacion-asistenteeducacion").default);

Vue.component("pastoral", require("./evaluaciones/evaluacion-pastoral").default);
Vue.component("evaluacion", require("./evaluaciones/evaluacion").default);

Vue.component("analisis-colegios", require("./analisis/analisis-colegios").default);
